import react, {useEffect,useState} from 'react';

import './index.scss';
import docLine from '../../assets/img/V7/docLine.svg';
import pdfLine from '../../assets/img/V7/pdfLine.svg';
import pptLine from '../../assets/img/V7/pptLine.svg';
import xslLine from '../../assets/img/V7/xslLine.svg';
import imgLineIcon from '../../assets/img/V7/imgLineIcon.svg';
import zipLineIcon from '../../assets/img/V7/zipLineIcon.svg';

const UploadFileIcon = ({fileType,isPic}) => {

    const fileIcon = {
        docm: (<img src={docLine} alt=""/>),
        doc: (<img src={docLine} alt=""/>),
        docx: (<img src={docLine} alt=""/>),
        ppt: (<img src={pptLine} alt=""/>),
        pptx: (<img src={pptLine} alt=""/>),
        pptm: (<img src={pptLine} alt=""/>),
        pdf: (<img src={pdfLine} alt=""/>),
        xls: (<img src={xslLine} alt=""/>),
        xlsx: (<img src={xslLine} alt=""/>),
        xlsm: (<img src={xslLine} alt=""/>),
        jpg: (<img src={imgLineIcon} alt=""/>),
        png: (<img src={imgLineIcon} alt=""/>),
        jpeg: (<img src={imgLineIcon} alt=""/>),
        zip: (<img src={zipLineIcon} alt=""/>),
    };

    return (fileIcon[fileType] || (<img src={docLine} alt=""/>))
}

export default UploadFileIcon;
